import { Box } from "@mui/material";
import { Form, Formik } from "formik";
import React from "react";
import CRMPlanDetails from "../../create-new-plan/crm-plan-details/crm-plan-details";
import CRMPriceDetails from "../../create-new-plan/crm-price-details/crm-price-detials";
import CRMBenefits from "../../create-new-plan/crm-benefits/crm-benefits";
import "./create-custom-plan.scss";
import { createCRMPlan } from "../../../../../api/crm-plans";
import { validationSchema } from "../../crm-plans-utils";
import { AlertComponent } from "../../../../../common/components";
import { AlertType } from "../../../../../utils/util-types";

interface CreateCustomPlanProps {
  initialValues: any;
  setIsLoading: (loading: boolean) => void;
  setAlertOpen: (loading: boolean) => void;
  setAlertMessage: (message: string) => void;
  setAlertType: (type: AlertType) => void;
  alertOpen?: boolean;
  alertMessage?: string;
  alertType?: AlertType;
  setCreateCustomPlanOpen: (open: boolean) => void;
  fetchPlans?: any;
}

const CreateCustomPlan: React.FC<CreateCustomPlanProps> = ({
  initialValues,
  setIsLoading,
  setAlertOpen,
  setAlertMessage,
  setAlertType,
  alertOpen,
  alertMessage,
  alertType,
  setCreateCustomPlanOpen,
  fetchPlans,
}) => {
  const onSubmit = async (values: any) => {
    setIsLoading(true);
    try {
      const supportLevel = values?.supportLevel
        ?.filter((item: any) => item?.checked)
        ?.map((item: any) => item?.name?.toLowerCase());
      const payload = {
        ...values,
        noOfUsers: Number(values?.noOfUsers ?? ""),
        automationRulesLimit: Number(values?.automationRulesLimit ?? ""),
        noOfLeads: Number(values?.noOfLeads ?? ""),
        noOfContacts: Number(values?.noOfContacts ?? ""),
        apiCallsPerMonth: Number(values?.apiCallsPerMonth ?? ""),
        supportLevel: supportLevel?.length ? supportLevel : null,
        storageLimit: values?.storageLimit?.value || null,
        reportingLevel: values?.reportingLevel === "Yes",
        planCategory: "custom",
      };
      if (payload?.planType) {
        payload.planType = payload?.planType?.value;
      } else {
        delete payload?.planType;
      }
      const response = await createCRMPlan(payload);
      setAlertMessage(
        response?.data?.data?.message ||
          "New Custom plan has been created successfully."
      );
      setAlertType("success");
      setAlertOpen(true);
      setCreateCustomPlanOpen(false);
      fetchPlans?.();
    } catch (error: any) {
      setAlertMessage(
        error?.response?.data?.message ||
          error?.response?.data?.error ||
          "Failed to create custom plan."
      );
      setAlertType("error");
      setAlertOpen(true);
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <Box className="create-custom-plan-content-wrapper">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        validateOnBlur
        onSubmit={onSubmit}
      >
        {({ resetForm, dirty, isValid }) => (
          <Form>
            <Box>
              <Box className="create-plan-price-wrapper" gap={2}>
                <Box className="create-plan-details-wrapper">
                  <CRMPlanDetails mode="create" />
                </Box>
                <Box className="create-plan-price-wrapper">
                  <CRMPriceDetails mode="create" />
                </Box>
              </Box>
              <Box className="create-crm-benefits-wrapprer">
                <CRMBenefits />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  paddingBottom: "20px",
                  marginTop: "20px",
                }}
              >
                <button
                  type="button"
                  className="cancel-button"
                  onClick={() => {
                    resetForm();
                  }}
                >
                  Reset Changes
                </button>
                <button
                  type="submit"
                  disabled={!dirty || !isValid}
                  className="cancel-button next-button-wrapper"
                >
                  Save Plan
                </button>
              </Box>
            </Box>
          </Form>
        )}
      </Formik>
      {alertOpen !== undefined &&
        alertMessage !== undefined &&
        alertType !== undefined && (
          <AlertComponent
            open={alertOpen}
            onClose={() => setAlertOpen(false)}
            type={alertType}
            message={alertMessage}
          />
        )}
    </Box>
  );
};

export default CreateCustomPlan;
